import apiConfig from '../../../apiConfig';

export type ServiceDurationRangeRow = {
  service_id: number;
  min_duration_minutes: number;
  max_duration_minutes: number;
};

export const fetchServiceDurationRanges = async (
  storeId: number,
  serviceIds: number[],
): Promise<ServiceDurationRangeRow[]> => {
  const url = new URL(`${apiConfig.baseURL}/api/customer-app/reservation/by-date/service-duration-ranges`);
  url.searchParams.set('store_id', String(storeId));
  url.searchParams.set('service_ids', serviceIds.join(','));

  const res = await fetch(url.toString(), { method: 'GET' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error((data as any).error || 'Failed to fetch service duration ranges');
  }

  const data = (await res.json()) as { ranges?: ServiceDurationRangeRow[] };
  return Array.isArray(data.ranges) ? data.ranges : [];
};
